import Record from "slotworks/model/gameplay/records/record";

export default class FreespinsWheelRecord extends Record {

    public spins: number;
    public total: number;
    public remain: number;
    public spinsWon: number;

    public giftedAdditional: number;

    public buyoutGame: boolean;
    public game: string;
    public is_complete: boolean;
    public total_base_game_win_amount: number;
    public total_bonus_games_win_amount: number;
}